import { OrderOperations } from "./OrderOperations"
import { OrderRelease } from "lib/types/generated/graphql-types"

export class Releases extends OrderOperations {
  constructor(release: OrderRelease[]) {
    super(release)
  }

  public completedReleases(): OrderRelease[] {
    return this.completedList() as OrderRelease[]
  }

  public getOngoingRelease(): OrderRelease {
    const ongoingList = this.ongoingList() as OrderRelease[]
    return ongoingList[0]
  }

  public failedReleases(): OrderRelease[] {
    return this.failedList() as OrderRelease[]
  }

  public orderLineReleased(orderLineId: string): OrderRelease | undefined {
    return this.completedReleases().find((release) =>
      release.orderLines.find((ol) => ol.orderLineId === orderLineId)
    )
  }
}
